import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import { useModal } from 'hooks/3catinfo/useModal';
import Players from 'components/3catinfo/Players';
import Boto from 'components/3catinfo/Boto';
import Icona from 'components/3catinfo/ui/Icona';
import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import styles from './itemVideoReel.module.scss';

const NoVideoReel = (props) => {
    return (
        <div className={styles.noVideo}>
            <div className={styles.contentNoVideo}>
                <Icona icona='avis' alt='avís' mida={48} isBlanc={true} className={styles.iconaNoVideo} />

                <div className={styles.textNovideo}>
                    Aquest vídeo no existeix..., però de ben segur que aquests també t&apos;agraden
                </div>
            </div>
        </div>
    );
};

const TotsReelsVistos = (props) => {
    const { removeModal } = useModal();
    const router = useRouter();

    const linkPortada = () => {
        router.push('/3catinfo');

        setTimeout(() => {
            removeModal();
        }, 1500);
    };

    return (
        <div className={styles.totsVistos}>
            <div className={styles.contentTotsVistos}>
                <Icona icona='checked_contorn_cercle' alt='checked' mida={48} isBlanc={true} className={styles.iconaNoVideo} />
                <div className={styles.textTotsVistos}>Ja t&apos;has posat al dia! Vols seguir explorant més notícies?</div>
                <Boto tag='button' text='Ves a la portada' className={styles.btnPortada} onClick={linkPortada} />
            </div>
        </div>
    );
};

const ItemVideoReel = forwardRef((props, publicRef) => {
    const { element, active, slot, numTotalItems, onNextVideo, setCurrentReel } = props;
    const { id, idRenderer } = element;
    const [playVideo, setPlayVideo] = useState(active);
    const reelRef = useRef();

    useImperativeHandle(publicRef, () => ({
        playVideoReel() {
            setPlayVideo(true);
        },
        stopVideoReel() {
            setPlayVideo(false);
        },
        getReelDiv() {
            return reelRef.current;
        }
    }));

    const playerControllerInstance = (playerController) => {
        playerController.on('loadedmetadata', () => {
            reelRef?.current?.querySelector('.bitmovinplayer-container')?.setAttribute('tabindex', '-1');
        });
    };

    const stylesModalReel = clsx({
        [styles.itemModalReel]: true,
        [styles.segonPla]: !active
    });

    const handleOnNextVideo = () => {
        onNextVideo();
        setPlayVideo(false);
    };

    const handleOnClick = (e) => {
        if (!active) {
            e.preventDefault();
            setCurrentReel(idRenderer);
            setPlayVideo(false);
        }
    };

    const _renderPlayer = () => {
        switch (id) {
            case 'no-video':
                return <NoVideoReel />;
            case 'end-of-feed':
                return <TotsReelsVistos />;
            default:
                if (numTotalItems < 3 && !active) {
                    return <div className={styles.noShowVideo}>&nbsp;</div>;
                } else {
                    return (
                        <Players
                            id={id}
                            tipus='reels'
                            dataVideo={element}
                            playVideo={playVideo || active}
                            onNextVideo={handleOnNextVideo}
                            playerControllerInstance={playerControllerInstance}
                        />
                    );
                }
        }
    };

    return (
        <div className={stylesModalReel} data-reel-id={idRenderer} data-reel-slot={slot} ref={publicRef} onClick={handleOnClick}>
            <article
                className={styles.innerItemModalReel}
                tabIndex={active ? 0 : -1}
                data-type='reel'
                ref={reelRef}
                aria-hidden={!!active}
            >
                {_renderPlayer()}
            </article>
        </div>
    );
});

ItemVideoReel.displayName = 'ItemVideoReel';
export default ItemVideoReel;
